import { RING_RADII } from '../types';

export function decaPts(r: number): [number, number][] {
  const pts: [number, number][] = [];
  for (let i = 0; i < 10; i++) {
    const a = (Math.PI * 2 * i) / 10 - Math.PI / 2;
    pts.push([r * Math.cos(a), r * Math.sin(a)]);
  }
  return pts;
}

export function decaPtsStr(r: number): string {
  return decaPts(r).map(p => p.join(',')).join(' ');
}

export function hexPoints(cx: number, cy: number, r: number): string {
  const pts: string[] = [];
  for (let i = 0; i < 6; i++) {
    const a = (Math.PI / 3) * i - Math.PI / 6;
    pts.push(`${cx + r * Math.cos(a)},${cy + r * Math.sin(a)}`);
  }
  return pts.join(' ');
}

/** Índice del anillo (0-4) en que cae el punto SVG, o -1 si está fuera */
export function ringAt(x: number, y: number, ringScale = 1): number {
  const safeScale = Math.max(1, ringScale);
  for (let i = 0; i < RING_RADII.length; i++) {
    const pts = decaPts(RING_RADII[i] * safeScale);
    let inside = false;
    for (let a = 0, b = pts.length - 1; a < pts.length; b = a++) {
      const [xi, yi] = pts[a];
      const [xj, yj] = pts[b];
      if ((yi > y) !== (yj > y) && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi) {
        inside = !inside;
      }
    }
    if (inside) return i;
  }
  return -1;
}

/** Offset de anclaje para que hilos de distintos procesos no se solapen */
export function anchorPoint(
  nx: number,
  ny: number,
  procIndex: number,
  totalProcs: number
): [number, number] {
  if (totalProcs <= 1) return [nx, ny];
  const R = 6;
  const a = (Math.PI * 2 * procIndex) / Math.max(totalProcs, 2);
  return [nx + R * Math.cos(a), ny + R * Math.sin(a)];
}
